<!-- <p>visitor-in-out-bound works!</p> -->
<div class="demo-chart-wrapper">
  <div
    echarts
    [options]="chartOption"
    [ngStyle]="height ? { height: height } : {}"
    class="demo-chart"
  ></div>
</div>
